import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSilkStrandSignature() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: btnRef,
    isVisible: btnVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="39105" id="crafting-your-outdoor-sanctuary" className="relative h-screen w-full overflow-hidden bg-[var(--color-primary)]">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline className="h-full w-full object-cover opacity-70 grayscale-[10%]" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624735/img/landscaping_image_7.png">
          <source src="/video/hero-background.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624735/img/landscaping_image_7.png" alt="Sunrise over a beautifully landscaped Rockland County estate" className="h-full w-full object-cover" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        
        {}
        <h1 ref={titleRef} className={`font-default text-5xl text-white transition-all duration-1000 ease-out md:text-7xl lg:text-[80px] lg:leading-tight ${titleVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          Crafting Your Outdoor Sanctuary
        </h1>

        {}
        <p ref={subRef} className={`mt-4 font-sans text-base font-medium tracking-widest text-white/90 uppercase transition-all delay-300 duration-1000 ease-out md:text-[20px] ${subVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>ROCKLAND & ORANGE COUNTY'S PREMIER LANDSCAPING COMPANY 
      </p>

        {}
        <div ref={btnRef} className={`mt-10 transition-all delay-500 duration-1000 ease-out ${btnVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Button asChild size="lg" className="rounded-sm border border-white/10 bg-[var(--color-accent)] px-10 py-7 text-lg font-semibold text-[var(--color-primary-foreground)] shadow-lg transition-all duration-500 hover:bg-[var(--color-accent)]/90 hover:shadow-[0_0_30px_var(--color-accent)] hover:scale-105">
            
          </Button>
        </div>
      </div>
    </section>;
}